import store from 'src/js/store';
import actions from '../actions';

function registerTool(tool) {
  store.dispatch(actions.registerTool(tool));
}

export default registerTool;
